import type * as Schema from 'src/types/graphql';

import type { AutosuggestItem } from './AddLocation';

interface ValidatorProps {
  locations: Schema.Location2[];
}

interface ValidationInput {
  validatorProps: ValidatorProps;
  value: AutosuggestItem;
}

interface TestInput {
  value: AutosuggestItem;
  locations: Schema.Location2[];
}

type TestOutput =
  | {
      duplicateLocation: Schema.Location2;
    }
  | true;

export const findDuplicateLocation = (
  location: AutosuggestItem,
  locations: Schema.Location2[],
): Schema.Location2 | null => {
  const { value } = location;

  return locations.find((loc) => loc.id === value) || null;
};

const testInput = ({ value, locations }: TestInput): TestOutput => {
  const duplicateLocation = findDuplicateLocation(value, locations);

  if (duplicateLocation) {
    return { duplicateLocation };
  }

  return true;
};

const getErrorMessage = (
  errorMessage: string,
  { value, locations }: TestInput,
): string => {
  const testResult = testInput({ value, locations });

  if (testResult !== true) {
    return errorMessage;
  }

  return '';
};

export const duplicatePreferredLocations = (errorMessage: string) => ({
  test: ({ value, validatorProps: { locations } }: ValidationInput) =>
    testInput({
      locations,
      value,
    }) === true,
  getErrorMessage: ({
    value,
    validatorProps: { locations },
  }: ValidationInput) =>
    Promise.resolve(
      getErrorMessage(errorMessage, {
        locations,
        value,
      }),
    ),
});
